import React from 'react';
import { Spinner } from '../../components/ui';
import EventForm from './EventForm';
import { fmtDate } from '../../utils/helpers';

// Phone Events: search + Add on one line, one compact card per event.
export default function EventsMobile({ vm }) {
  const { filtered, loading, can, q, setQ, startAdd, startEdit, del } = vm;
  return (
    <div>
      <div className="page-head">
        <h1>Events</h1>
        <span className="count-pill">{filtered.length}</span>
      </div>

      <div className="ev-m-toolbar">
        <input placeholder="Search..." value={q} onChange={(e) => setQ(e.target.value)} />
        {can.add && <button className="btn primary" onClick={startAdd}>+ Add Event</button>}
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : filtered.length === 0 ? (
          <div className="card card-pad empty">No events yet.{!can.add && ' Ask an Admin to create one.'}</div>
        ) : (
          <div className="mobile-card-list">
            {filtered.map(row => (
              <div key={row.EventId} className="card card-pad mobile-record-card ev-m-card row-link" onClick={() => vm.openRow(row)}>
                <div className="mobile-card-head">
                  <strong className="mobile-title">{row.EventName || '-'}</strong>
                  <div style={{ flex: 1 }} />
                  {row.Status && <span className="chip pend">{row.Status}</span>}
                </div>
                <div className="ev-m-line">
                  <span>{row.EventTypeName || row.EventType || '-'}</span>
                  <span className="muted">· {fmtDate(row.EventStartDate)} – {fmtDate(row.EventEndDate)}</span>
                </div>
                <div className="ev-m-line muted">
                  Admin: {[row.EventAdminName, row.EventAdminMobile].filter(Boolean).join(' · ') || '-'}
                </div>
                {(row.Venue || row.City) && (
                  <div className="ev-m-line muted">📍 {[row.Venue, row.City].filter(Boolean).join(', ')}</div>
                )}
                {(can.edit || can.delete) && (
                  <div className="mobile-actions" onClick={(e) => e.stopPropagation()}>
                    {can.edit && <button className="btn light sm" onClick={() => startEdit(row)}>Edit</button>}
                    {can.delete && <button className="btn danger sm" onClick={() => del(row)}>Del</button>}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

      <EventForm vm={vm} />
    </div>
  );
}
